import { render } from "./Index.vue?vue&type=template&id=e84ea1f6"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=e84ea1f6&lang=css"
script.render = render

export default script